import { Civil3dFeatureType } from '../constants/civil3d-feature-type';
import { ArcgisCivil3dPropertyMappingApiModel } from './arcgis-civil3d-property-mapping.model';
import { AutodeskLayerApiModel } from './autodesk-layer.model';
import { AlignmentStyleApiModel } from './alignment-style.model';
import { ArcgisCivil3dSettingApiModel } from './arcgis-civil3d-setting.model';

export type ArcgisCivil3dAlignmentSettingApiModel = ArcgisCivil3dSettingApiModel & {
  civil3dFeatureType: string;
  alignmentStyle: { id: number } | null;
  autodeskLayer: { id: number } | null;
};

export type WithCivil3dFeatureType = ArcgisCivil3dAlignmentSettingApiModel & {
  civil3dFeatureType: Civil3dFeatureType;
};

export type WithAlignmentStyle = ArcgisCivil3dAlignmentSettingApiModel & {
  alignmentStyle: AlignmentStyleApiModel | null;
};

export type WithAutodeskLayer = ArcgisCivil3dAlignmentSettingApiModel & {
  autodeskLayer: (Pick<AutodeskLayerApiModel, 'id'> & { name: string }) | null;
};

export type WithPropertyMappings = ArcgisCivil3dAlignmentSettingApiModel & {
  propertyMappings: ArcgisCivil3dPropertyMappingApiModel[];
};

export enum ArcgisCivil3dAlignmentSettingRelationship {
  CONFIGURATION = 'CONFIGURATION',
  ARCGIS_FEATURE_CLASS = 'ARCGIS_FEATURE_CLASS',
  ALIGNMENT_STYLE = 'ALIGNMENT_STYLE',
  AUTODESK_LAYER = 'AUTODESK_LAYER',
  PROPERTY_MAPPINGS = 'PROPERTY_MAPPINGS',
}
